import React from 'react';

const Resume = () => {
    return (
        <div>
            <h2>Please show actor resume</h2>
        </div>
    );
};

export default Resume;